export const EMAIL_SIGNATURE_FILE = 'signature.txt';
